<template>
  <div class="font-icon-list col-lg-2 col-md-3 col-sm-4 col-xs-6 col-xs-6">
    <div class="font-icon-detail" @click="$emit('toggle', {databaseColumnName, displayColumnName})">
      <h2
        :class="{
          off: isClassOff,
          on: isClassOn
        }"
      >
        {{ displayStatus }}
      </h2>
      <p>{{displayColumnName}}</p>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "EditBoxBoolean",
  props: {
    databaseColumnName: String,
    data: Object,
    displayColumnName: String,
    revert: Boolean
  },
  created() {
  },
  computed: {
    isClassOn: function() {
      let flag = this.data[this.databaseColumnName] == 1 ? true : false;
      flag = !this.revert ? flag : !flag;
      return flag;
    },
    isClassOff: function() {
      return !this.isClassOn;
    },
    displayStatus: function() {
      return this.isClassOn ? '啟用' : '關閉';
    }
  }
};
</script>
<style scoped>
.off {
  color: red;
}
.on {
  color: rgb(0, 255, 0);
}
</style>
